import Segment from '@advisor/models/store/settings/Segment';

export default class SegmentSettings {
  constructor() {
    this.segments = [];
    this.currentSegment = new Segment();
    this.goalThumbnailList = [];
  }
}
